export const ConsumerPhoneNumberFormStyles = {
  formContainer: 'flex flex-col w-full items-center',
  button: 'text-xl sm:text-2xl my-3',
  errorBanner: 'mb-4 mt-4 max-w-xs'
}
